module.exports = __webpack_public_path__ + "static/media/cash-for-scrap-cars.a1a9ec3d.png";